import Image from 'next/image';
import Link from 'next/link';
import {MobileNumber} from '@/constants/contact';
import {cdnImage} from '@/util/cdnImage';
import styles from './WhatsAppFloat.module.scss';

const WHATSAPP_LINK = `https://wa.me/${MobileNumber}?text=Hi!%20I%20want%20to%20talk%20about%20your%20services%20and%20products.`;

/** Floating WhatsApp button (bottom right, desktop only). Plain stand-in for the old MUI Box. */
const WhatsAppFloat = () => (
    <div className={styles.float}>
        <Link href={WHATSAPP_LINK} target="_blank" rel="nofollow noopener noreferrer" aria-label="whatsapp float">
            <Image src={cdnImage('Home-page/whatsapp.svg')} alt="WhatsApp" width={30} height={30} style={{marginTop: '1px'}} />
        </Link>
    </div>
);

export default WhatsAppFloat;
